import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  ViewChild,
  ContentChild,
  Attribute,
  OnInit,
  OnChanges,
  TemplateRef,
  ElementRef,
  SimpleChanges
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ActionMenuButtonItem, NavigationMenuButtonItem } from '@models/menu-button.model';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

let lastId = 0;

@Component({
  selector: 'ts-menu-button',
  templateUrl: './menu-button.component.html',
  imports: [CommonModule, NgbDropdownModule, RouterLink]
})
export class MenuButtonComponent implements OnInit, OnChanges {
  @Input() links: NavigationMenuButtonItem[] = [];
  @Input() actions: ActionMenuButtonItem[] = [];
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() class: string = 'd-inline-block';
  @Input() buttonClass: string = 'btn btn-outline-primary';
  @Input() menuClass: string | undefined = undefined;
  @Input() menuItemClass: string | undefined = undefined;
  @ViewChild('dropdownInstance', { static: true }) dropdown: NgbDropdown;
  @ViewChild('button') buttonRef: ElementRef<any> | undefined = undefined;
  @ViewChild('menu') menuRef: ElementRef<any> | undefined = undefined;
  @ContentChild('menuButton') menuButtonTemplateRef: TemplateRef<any> | null = null;
  @ContentChild('menuItem') menuItemTemplateRef: TemplateRef<
    ActionMenuButtonItem | NavigationMenuButtonItem
  > | null = null;

  button_id: string = `ts-menubutton-button${++lastId}`;
  menu_id: string = `ts-menubutton-menu${lastId}`;

  constructor(@Attribute('aria-label') public ariaLabel: string) {}

  ngOnInit(): void {
    if (this.links.length > 0 && this.actions.length > 0)
      throw new Error('MenuButtonComponent: cannot have both links and actions');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.links.length === 0 && this.actions.length === 0 && this.dropdown.isOpen())
      this.dropdown.close();
  }

  menuDisabled(): boolean {
    return this.disabled || (this.links.length === 0 && this.actions.length === 0);
  }
}
